import * as React from 'react';
import StarSvgView from '../views/star-svg';
import { AppState } from '../classes/app-state';
import { connect } from 'react-redux';

interface ISvgStarProps {
    isFavorite: boolean;
}

const favoritesStatus: React.StatelessComponent<ISvgStarProps> = props => {
    return (
        <React.Fragment>
            <StarSvgView isFavorite={props.isFavorite} />
            {
                props.isFavorite ? "Added to Favorites" : "Add to Favorites"
            }
        </React.Fragment>
    );
}


function mapStateToProps(state: AppState): ISvgStarProps {
    return {
        isFavorite: state.favoritesState.isFavorite
    }
}

export default connect<ISvgStarProps>(mapStateToProps)(favoritesStatus);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/components/favorites-status.tsx